import axiosInstance from '../../../core/api/axios';

export async function onLikeContent(slug: string) {
  try {
    const response = await axiosInstance.post(`/lessons/${slug}/review`, {
      review: 'like',
    });

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function onDislikeContent(slug: string) {
  try {
    const response = await axiosInstance.post(`/lessons/${slug}/review`, {
      review: 'dislike',
    });

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function onFavoriteContent(body: {
  category: string;
  targetId: string;
  targetType: string;
}) {
  try {
    const response = await axiosInstance.post(`/favorites`, body);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function onFavoriteListing(
  body: {
    category: string;
    targetId: string;
    targetType: string;
  },
) {
  try {
    const { data } = await axiosInstance.post(`/favorites`, body);

    return data;
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
}
